<template>
  <div class="login">
    <div class="content">
      <div class="logo">
        <img :src="logo" alt="" @click="$router.push({
          name: 'Home'
        })">
      </div>
      <div class="middle">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm">
          <el-form-item label="用户名" prop="userName">
            <el-col :span="18">
              <el-input type="text" placeholder="请输入用户名" suffix-icon="iconfont ys-yonghuming" v-model="ruleForm.userName" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="6" class="btns">
              <router-link to="/register">立即注册</router-link>
            </el-col>
          </el-form-item>
          <el-form-item label="密码" prop="userPass">
            <el-col :span="18">
              <el-input type="password" placeholder="请输入密码" suffix-icon="iconfont ys-ai-password" v-model="ruleForm.userPass" auto-complete="off"></el-input>
            </el-col>
            <el-col :span="6" class="btns">
              <router-link to="/retrievepass">忘记密码</router-link>
            </el-col>
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <el-col :span="8">
              <el-input maxlength="4" placeholder="请输入验证码" v-model="ruleForm.code"></el-input>
            </el-col>
            <el-col :span="8" class="btns">
              <img :src="getCode" alt="">
            </el-col>
            <el-col :span="3" class="btns">
              <i class="el-icon-refresh" @click="refreshCode"></i>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="18">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="18">
              <el-button class="goLogin" type="text" @click="submitForm('ruleForm')">立即登录</el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer-d">
        <ul>
          <li><a href="http://e-zt.cn/other/#d2" target="_blank">关于我们</a></li>
          <li><a href="http://e-zt.cn/other/#d3" target="_blank">联系我们</a></li>
          <li><a href="http://e-zt.cn/other/#d3" target="_blank">帮助中心</a></li>
          <li><a href="http://e-zt.cn/other/#d4" target="_blank">网站地图</a></li>
        </ul>
        <div class="help">
          <ol>
            <li><a href="http://e-zt.cn/other/#d5" target="_blank">版权信息</a></li>
            <li><a href="http://e-zt.cn/other/#d5" target="_blank">网证信息</a></li>
            <li><a href="http://e-zt.cn/other/#d3" target="_blank">客服电话</a></li>
            <li><a href="http://e-zt.cn/other/#d3" target="_blank">客服邮箱</a></li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    var validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    var validateUserName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      }
    }
    var validateUserPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {
      obj: {
        id: '1',
        userName: '',
        nickName: '',
        userIcon: '',
        phone: '',
        email: ''
      },
      logo: require('@/assets/images/login/logo.png'),
      getCode: this.$allUrl.getPictureVeritfCode,
      ruleForm: {
        userName: '',
        userPass: '',
        code: ''
      },
      checked: true,
      rules: {
        userName: [
          { validator: validateUserName, trigger: 'blur' }
        ],
        userPass: [
          { validator: validateUserPass, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      let self = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          self.goLogin()
        } else {
          return false
        }
      })
    },
    refreshCode () {
      this.getCode = `${this.$allUrl.getPictureVeritfCode}?time=${Math.random()}`
    },
    goLogin () {
      let self = this
      const userName = self.ruleForm.userName
      // const password = self.ruleForm.userPass
      const password = self.$md5(self.ruleForm.userPass)
      const code = self.ruleForm.code
      const url = `?userName=${userName}&password=${password}&code=${code}`
      self.$get(self.$allUrl.login + url).then(res => {
        if (res.code === '0') {
          window.sessionStorage.setItem('ysUserMsg', JSON.stringify(res.data))
          self.$store.dispatch('update_userMsg', res.data)
          self.$message({
            message: '恭喜您，登录成功！',
            type: 'success',
            onClose: function () {
              self.$router.push({
                name: 'Home'
              })
            }
          })
        } else {
          self.$notify.error({
            title: '错误',
            message: res.message
          })
          self.ruleForm.code = ''
          self.refreshCode()
        }
      })
    }
  },
  mounted () {
    if (this.checked) {
      // this.ruleForm.userName = 'lianchao'
      // this.ruleForm.userPass = '123456'
    }
  }
}
</script>
<style lang="less" scoped>
  a{
    text-decoration: none
  }
  .login{
    min-width: 1200px;
    background-image: url('../../assets/images/login/bj.png');
    min-height: 785px;
    width:100%;
    height:100%;
    background-size:100% 100%;
    position:absolute;
    filter:progid:DXImageTransform.Microsoft.AlphaImageLoader(src='../../assets/images/login/bj.png',sizingMethod='scale');
    .content{
      width: 1200px;
      margin: auto;
      height: 500px;
      .logo{
        text-align: center;
        padding-top: 65px;
        & img{
          cursor: pointer;
        }
      }
      .middle{
        width: 500px;
        background-color: white;
        margin: auto;
        margin-top: 70px;
        border-radius: 6px;
        box-shadow: 0 0 15px #888888;
        padding: 30px 20px;
        .btns{
          padding-left: 20px;
          img{
            width: 100%;
            display: block;
          }
          i{
            font-size: 24px;
            cursor: pointer;
            vertical-align: middle;
          }
        }
        .goLogin{
          width: 100%;
          background-image: url('../../assets/images/login/dl.png');
          background-repeat: no-repeat;
          background-size:100% 100%;
          height: 50px;
          color: #ffd2d9;
          font-size: 20px;
        }
      }
      .footer-d{
        ul{
          list-style: none;
          padding: 0;
          margin: 0;
          display: flex;
          padding: 60px 0;
          font-size: 16px;
          li{
            flex: 1;
            text-align: center;
            border-right: 1px solid black;
          }
          li:last-child{
            border: 0;
          }
        }
        .help{
          width: 450px;
          margin: auto;
          ol{
            list-style: none;
            padding: 0;
            margin: 0;
            display: flex;
            font-size: 16px;
            li{
              flex: 1;
              text-align: center;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login/login.vue